<template>
    <div class="moderation page-container">

        <PageContent :content="content" :scrolling="true">
        </PageContent>


    </div>
</template>
<script>
    import kultur from '../content/kultur.json'
    import PageContent from "../components/PageContent";

    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: 'Dr Thumm GmbH' }
                ]
            }
        },
        data() {
            return {
                actualPage: 0,
                paginationFinish: false,
                fotoPapa: true,
                content: {
                    kultur
                },
                paginationHeight: 0
            }
        },
        computed: {
            paginationStyle() {
                return {
                    height: `${this.paginationHeight}px`
                }
            },
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )

                if (route.includes('historie')) this.fotoPapa = false
                else this.fotoPapa = true

                let content = this.content
                console.log(content.moderation)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })

                return content
            },
            pagination() {
                if (this.actualPage < 0) this.actualPage = 0
                else if (this.page.pagination[this.actualPage] === undefined) this.actualPage -= 1
                return this.page.pagination[this.actualPage]
            }

        },
        mounted() {
            this.getHighestPagination()
        },
        methods: {
            getHighestPagination() {
                var maxHeight = Math.max.apply(null, $(".pagination-text p").map(function ()
                {
                    return $(this).height();
                }).get());
                this.paginationHeight = maxHeight
                this.paginationFinish = true
            },
            changePage(page) {
                this.actualPage = page
                this.getHighestPagination()
            }
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass" scoped>
</style>